import { Link } from 'react-router-dom';
import { useSiteConfig } from '@/hooks/useSiteConfig';

const footerNavLinks = [
  {
    title: '产品服务',
    links: [
      { label: '下载中心', href: '/download' },
      { label: '功能介绍', href: '/features' },
      { label: '漫画分类', href: '/categories' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌故事', href: '/about' },
      { label: '用户评价', href: '/reviews' },
      { label: '新番预告', href: '/schedule' },
    ],
  },
  {
    title: '帮助支持',
    links: [
      { label: '帮助中心', href: '/help' },
      { label: '常见问题', href: '/help#faq' },
      { label: '使用指南', href: '/help#guides' },
    ],
  },
  {
    title: '法律声明',
    links: [
      { label: '隐私政策', href: '/privacy' },
      { label: '用户协议', href: '/terms' },
    ],
  },
];

export default function Footer() {
  const { config } = useSiteConfig();

  return (
    <footer className="bg-white border-t border-gray-100">
      {/* 主内容 */}
      <div className="section-padding">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10 lg:gap-12">
          {/* 品牌列 */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 rounded-xl overflow-hidden bg-pink-500 flex items-center justify-center">
                <img
                  src="/images/logo/logo.webp"
                  alt="天天漫画"
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="font-serif text-lg font-bold text-gray-900">天天漫画</span>
            </Link>
            <p className="text-sm text-gray-500 leading-relaxed mb-6">
              海量优质漫画阅读APP，为千万用户提供高清流畅的阅读体验。
            </p>
            <div className="flex gap-3">
              {config.socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.url}
                  rel="nofollow"
                  className="w-9 h-9 rounded-full border border-gray-200 flex items-center justify-center text-gray-400 hover:border-pink-400 hover:text-pink-500 transition-all duration-300"
                  aria-label={social.label}
                >
                  <i className={`${social.icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          {/* 导航列 */}
          {footerNavLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-bold text-gray-900 mb-5 flex items-center gap-2">
                <span className="w-4 h-px bg-pink-400" />
                {group.title}
              </h4>
              <ul className="space-y-3">
                {group.links.map((item) => (
                  <li key={item.label}>
                    <Link
                      to={item.href}
                      className="text-sm text-gray-500 hover:text-pink-500 transition-colors duration-300"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* 底部条 */}
      <div className="border-t border-gray-100 px-4 md:px-8 lg:px-16 xl:px-24 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-400">{config.copyrightText}</p>
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-gray-400">
            <a
              href={`mailto:${config.contactEmail}`}
              className="hover:text-pink-500 transition-colors"
            >
              联系邮箱：{config.contactEmail}
            </a>
            <span className="hidden sm:inline-block w-px h-3 bg-gray-200" />
            <span className="hover:text-pink-500 transition-colors cursor-default">
              备案号：{config.icpNumber}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}